import React, { useState } from 'react';
import Autocomplete from 'react-google-autocomplete';

// 🛑 Moving this OUTSIDE the component prevents the "loss of focus" freeze!
const searchOptions = {
  types: ['(cities)'],
};

const LocationAutocomplete = ({ onLocationCalculated }) => {
  const [loading, setLoading] = useState(false);

  const handlePlaceSelected = async (place) => {
    if (!place.geometry) return;
    setLoading(true);
    
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const address = place.formatted_address;

    try {
      const timestamp = Math.floor(Date.now() / 1000);
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
      const tzResponse = await fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${apiKey}`);
      const tzData = await tzResponse.json();

      if (tzData.status === 'OK') {
        const totalOffsetSeconds = tzData.rawOffset + tzData.dstOffset;
        const offsetHours = totalOffsetSeconds / 3600;

        onLocationCalculated({
          lat: lat,
          lng: lng,
          address: address,
          utcOffset: offsetHours
        });
      } else {
        console.error("Timezone fetch failed:", tzData.status);
        alert("Cosmic interference: Could not calculate the time zone for this location.");
      }
    } catch (error) {
      console.error("Error fetching timezone:", error);
    }
    
    setLoading(false);
  };

  return (
    <div style={{ width: '100%' }}>
      <Autocomplete
        apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        onPlaceSelected={handlePlaceSelected}
        options={searchOptions}
        placeholder={loading ? "Aligning coordinates..." : "Enter birth city (e.g., Zapotlanejo)"}
        style={{
          width: '100%',
          padding: '10px',
          background: '#05070a',
          border: '1px solid #30363d',
          color: 'white',
          borderRadius: '4px',
          fontSize: '1rem',
          outline: 'none',
          boxSizing: 'border-box'
        }}
      />
    </div>
  );
};

export default LocationAutocomplete;